import classnames from 'classnames'

export const InputField = ({
  name,
  label,
  type,
  placeholder,
  error,
  defaultValue,
  value,
  helper,
  helperDescription,
  rounded,
  className,
  filter,
  containerClassName,
  readOnly,
  onChange,
  disable,
}: {
  name: string
  label: string
  type: 'input' | 'password' | 'number' | 'date'
  placeholder?: string
  error?: string
  defaultValue?: number | string | Array<string> | undefined | null
  value?: string | number
  helper?: string
  helperDescription?: string
  options?: { name: string; value: string }[]
  rounded?: boolean
  className?: string
  filter?: boolean
  containerClassName?: string
  readOnly?: boolean
  disable?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onValueChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
}): JSX.Element => {
  return (
    <div className="flex flex-col gap-2 w-full">
      {label ? (
        <label
          htmlFor={name}
          className="flex flex-col gap-2 text-sm tracking-wider font-light w-full"
        >
          <span>{label}</span>
        </label>
      ) : null}
      {helper ? (
        <label
          htmlFor={name}
          className="flex flex-col gap-2 text-sm tracking-wider font-light w-full"
        >
          <span>{helper}</span>
        </label>
      ) : null}
      <input
        readOnly={readOnly}
        disabled={disable}
        // defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        id={name}
        type={type}
        placeholder={placeholder}
        className="block border p-2 text-black w-full tracking-wider rounded"
      />
      {/* {error && <label className="text-red-400">{error}</label>} */}
      {error ? (
        <div className={'text-red text-xs mt-1 tracking-wider'} role="alert">
          {error}
        </div>
      ) : null}
    </div>
  )
}
